import React from "react";
import { Button } from "../components/ui/button";
import { Heading } from "../components/ui/heading";
import { Text } from "../components/ui/text";

const Unauthorized = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      <div className="max-w-md">
        <Heading className="mb-6">Access Denied</Heading>
        <Text className="mb-8">
          Sorry, you don't have permission to access this page. Please contact
          your administrator if you believe this is an error.
        </Text>
      </div>
    </div>
  );
};

export default Unauthorized;
